import operations from '~/helpers/device-operations';
import { homekitStatus, hwVersion, lastReset, lastStatusStored } from '~/helpers/fields-description';
import { connection, ip } from '~/helpers/network-fields-description';
import { Operation } from '~/interfaces/device.interface';
import { FieldObject } from '~/interfaces/field.interface';
import { NADevice } from '~/models/NADevice.model';

export class Gateway extends NADevice {
    hasOperationMainloop = true;
    hasOperationReset = true;
    homeId?: string;
    modules_bridged?: string[];
    homekit_status?: string;
    hasModulesCount = true;
    isWired = true;

    get deviceOperations(): Operation[] {
        const deviceOperations = super.deviceOperations;
        if (this.hasOperationMainloop) {
            deviceOperations.push(operations.mainloop({ callback: this.mainloop, disabled: this.isMainloopDisabled }));
        }
        if (this.hasOperationImportData) {
            deviceOperations.push(operations.importData({
                callback: this.importData as () => Promise<any>,
                params: { device_id: this.id, type: this.type },
            }));
        }
        return deviceOperations;
    }

    get outdatedLastStatusStored() {
        return this.last_status_store
            ? Date.now() / 1000 - this.last_status_store > this.MAX_TIME_BEFORE_UNKNOWN
            : true;
    }

    get column() {
        return '';
    }

    get canBeConsideredDisconnected() {
        const disconnection = this.network?.server_node?.disconnection;
        return disconnection
            ? Date.now() / 1000 - disconnection > this.MAX_TIME_BEFORE_CONSIDERED_DISCONNECTED
            : true;
    }

    get fieldHwVersion(): FieldObject | undefined {
        return hwVersion(this.hw_version);
    }
    get fieldLastStatusStored(): FieldObject | undefined {
        return lastStatusStored(this.last_status_store || this.last_connection_status, { 'error--text': this.outdatedLastStatusStored });
    }
    get fieldLastReset(): FieldObject | undefined {
        return lastReset(this.last_reset);
    }
    get fieldHomekitStatus(): FieldObject | undefined {
        if (typeof this.homekit_status !== 'undefined') {
            return homekitStatus(this.homekit_status);
        }
    }

    getNetworkFields(): FieldObject[] {
        if (!this.network) {
            return [{ key: 'No Info', value: '' }];
        } else {
            const fields: FieldObject[] = [
                ip(this.network.ip),
            ];
            if (this.network.connection === 'wifi' || !this.network.connection || typeof this.network.connection === 'number') {
                fields.push(connection(this.getWifiIcon(this.network.wifi_status), this.network.wifi_status));
            }
            return fields;
        }
    }

    reset = async () => {
        await super.reset({ device_id: this.id });
    };

}
